import { BreakPointCondition, UI, useBreakpointIf } from '@genial/components';
import { Color, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { useNavigation } from '@react-navigation/native';
import { Box, Button } from 'native-base';
import { useCallback } from 'react';

import { OrderByModal } from '../../../../../components/OrderByModal';
import { useDynamicOrdinationContext } from '../../../../../contexts/DynamicOrdination';
import { SignedInNavigationScreenNavigationProp } from '../../../../../routes/types';
import { orderHistoryByAtom } from '../../../../../store/orderHistory/atom';

export const OrderHistoryOrderBy = () => {
  const isDesktop = useBreakpointValue({ base: false, lg: true });
  const { navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();

  const { appliedOrderBy, tableHead } = useDynamicOrdinationContext();

  const getIsOrdering = () => {
    if (appliedOrderBy) {
      const currentOrderBy = tableHead.find(
        ({ orderValue }) => orderValue === appliedOrderBy.value
      );

      return !!currentOrderBy?.title;
    }

    return false;
  };

  if (isDesktop) {
    return null;
  }

  return (
    <Button
      mr="inline.nano"
      onPress={() => navigate('OrderHistoryOrderByModal')}
      alignItems="center"
      justifyContent="center"
      variant="secondary"
      bg="white"
      w="52px">
      <Box>
        <UI.Icon name="Ordering" size="xxs" />
        {getIsOrdering() && (
          <Box
            w={Typography['fontsize.md']}
            h={Typography['fontsize.md']}
            borderRadius="full"
            background={Color['brand.tertiary.light']}
            position="absolute"
            top={-12}
            right={-22}
          />
        )}
      </Box>
    </Button>
  );
};

export const OrderHistoryOrderByModal = () => {
  const navigation = useNavigation();
  const isMobile = useBreakpointIf(BreakPointCondition.EqualOrDown, 'sm');
  const isTablet = useBreakpointIf(BreakPointCondition.EqualOrDown, 'lg');

  const goBack = useCallback(() => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    }
  }, [navigation]);

  const getSliderModalWidth = () => {
    if (isMobile) {
      return 1;
    }
    if (isTablet) {
      return 0.5;
    }
    return 0.3;
  };

  return (
    <OrderByModal
      onClose={goBack}
      sliderModalWidth={getSliderModalWidth()}
      orderByAtom={orderHistoryByAtom}
    />
  );
};
